import { MAX_TEXT_FILE_DOWNLOAD_SIZE_BYTES } from '../../../../../constants/index.js';
import type { DataFile } from '../../../../../services/dataHubService.interface.js';

import { canParseConversation } from './parseConversation.js';

export type DataFileParser = 'conversation';

const BINARY_FILE_TYPES = new Set(['audioStream', 'videoStream']);
const PREVIEWABLE_TEXT_EXTENSIONS = new Set([
  'json',
  'jsonl',
  'srt',
  'tsv',
  'txt',
  'vtt',
]);

export function canLoadDataFilePreview(file: DataFile): boolean {
  if (
    file.fileSizeInBytes !== undefined &&
    file.fileSizeInBytes > MAX_TEXT_FILE_DOWNLOAD_SIZE_BYTES
  ) {
    return false;
  }

  if (file.fileType !== undefined && BINARY_FILE_TYPES.has(file.fileType)) {
    return false;
  }

  if (file.fileType?.trim().toLowerCase() === 'transcript') {
    return true;
  }

  const extension = file.fileName?.split('.').pop()?.toLowerCase();
  return extension !== undefined && PREVIEWABLE_TEXT_EXTENSIONS.has(extension);
}

export function detectDataFileParser(
  source: string,
  file: DataFile,
): DataFileParser | null {
  if (
    file.fileType?.trim().toLowerCase() === 'transcript' ||
    canParseConversation(source, file.fileName)
  ) {
    return 'conversation';
  }

  return null;
}
